import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import * as React from 'react';
import styled from 'styled-components';
import { spacing2x } from '../../styles/spacing.js';
import { useAccordionItemContext } from '../AccordionItemContext/AccordionItemContext.js';
import { Box } from '../Box/Box.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children"];
var StyledBox = styled(Box).withConfig({
  displayName: "AccordionPanel__StyledBox",
  componentId: "sc-1x2eley-0"
})(["&&{border:none;padding-top:", ";max-height:320px;overflow-y:auto;width:318px;}"], spacing2x);
var AccordionPanel = /*#__PURE__*/React.forwardRef(function AccordionPanel2(props, ref) {
  var children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  var _useAccordionItemCont = useAccordionItemContext(),
      headerId = _useAccordionItemCont.headerId,
      open = _useAccordionItemCont.open,
      panelId = _useAccordionItemCont.panelId;

  return open ? /*#__PURE__*/jsx(StyledBox, _objectSpread(_objectSpread({
    "aria-labelledby": headerId,
    id: panelId,
    padding: 4,
    ref: ref,
    role: "region"
  }, rest), {}, {
    children: children
  })) : null;
});
AccordionPanel.propTypes = {
  "children": _PropTypes.node
};
AccordionPanel.displayName = "AccordionPanel";

export { AccordionPanel };
